export class otpValidation{
    "accountNo": string;
    "authType": string;
    "authValue": string;
    "token": string;
}